// extracted by mini-css-extract-plugin
export default {"appIconSize":"24px","appIcon":"AppAvatar-module__appIcon--c981b"};